<template>
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6>
            <div>
              <h3>Reset Password</h3>
              <p>Follow the steps below to reset your password</p>
            </div>
           <v-stepper v-model="stp" vertical>
             <v-stepper-step :complete="stp > 1" step="1">
                Let's check if your e-mail is in the Database
                <small>Please enter the email you used to sign up</small>
              </v-stepper-step>
              <v-stepper-content step="1">
                  <form>
                     <v-text-field prepend-icon="person" name="login" label="E-mail" type="text" v-model="email"></v-text-field>
                     <v-btn dark @click.native="verifyEmail">Verify Email</v-btn>
                   </form>
              </v-stepper-content>
              <v-stepper-step :complete="stp > 2" step="2">Enter a new password</v-stepper-step>
               <v-stepper-content step="2">
                  <form>
                     <v-text-field 
                      prepend-icon="lock"
                      name="password"
                      label="New Password"
                      :type="show1 ? 'text' : 'password'"
                      v-model = "password"
                      hint = "At least 8 characters"
                      :append-icon="show1 ? 'visibility_off': 'visibility'"
                      :rules="[rules.required, rules.min]"
                      @click:append="show1 = !show1"
                     ></v-text-field>
                     <v-text-field 
                      prepend-icon="lock"
                      name="password2"
                      label="Confirm Password"
                      :type="show2 ? 'text' : 'password'"
                      v-model="confirmPassword"
                      :append-icon="show2 ? 'visibility_off': 'visibility'"
                      :rules="[rules.required, rules.min]"
                      @click:append="show2 = !show2"
                     ></v-text-field>
                     <captcha
                       ref="recaptcha"
                        :sitekey="siteKey"
                        @verify = "onVerify"
                        @expired= "onExpired"
                      ></captcha>
                     <v-btn dark @click.native="resetPassword">Reset Password</v-btn>
                   </form>
              </v-stepper-content>
              <v-stepper-step :complete="stp > 3" step="3">Login with your new Password</v-stepper-step>
               <v-stepper-content step="3">
                 
                  <span>Click the button to login page</span>
                  <v-btn dark @click.native="toLoginPage">Login</v-btn>
              </v-stepper-content>
           </v-stepper>
           <v-btn dark @click.native="cancel">Cancel</v-btn> 
            <v-dialog v-model="openDialog" max-width="500px" >
              <v-card>
                <v-card-title class="error white--text">
                  <v-icon class="white--text pr-3">warning</v-icon><span>Something is wrong...</span>
                  <v-icon class="white--text pl-2">fa-frown-o</v-icon>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                <p>{{errorMsg}}</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" @click.stop="openDialog=false">ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>
  

<script>
import {mapGetters} from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'Reset',
  components: {
    captcha: VueRecaptcha
  },
  data () {
    return {
      siteKey: '6LckcoUUAAAAAADvzeIYlFgM7XyhZqaTPUx-upzK',
      stp: 0,
      email: '',
      password: '',
      confirmPassword: '',
      openDialog: false,
      errorMsg: '',
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters'
      },
      captchaToken: ''
    }
  },
  computed: {
    ...mapGetters(
      {
        isVerified: 'isVerified',
        isPasswordSet: 'isPasswordSet'
      }
    )
  },
  watch: {
    isVerified () {
      if (this.isVerified) {
        this.stp++
      } else {
        this.openDialog = true
        this.email = ''
        this.errorMsg = 'Your e-mail is not in the Database'
        this.$store.dispatch('resetState')
      }
    },
    isPasswordSet () {
      if (this.isPasswordSet) {
        this.stp++
      } else {
        this.openDialog = true
        this.errorMsg = 'Password does not match!'
      }
    }
  },
  methods: {
    verifyEmail () {
      if (this.email !== '') {
        this.$store.dispatch('checkEmail', {
          email: this.email,
          url: 'auth/checkEmail'
        })
      } else {
        this.openDialog = true
        this.errorMsg = 'Please type an e-mail'
      }
    },
    cancel () {
      this.stp = 0
      this.password = ''
      this.confirmPassword = ''
      this.email = ''
      this.errorMsg = ''
      this.$store.dispatch('resetState')
      this.$router.push('/')
    },
    resetPassword () {
      var obj = ''
      if (this.password === '' || this.confirmPassword === '') {
        this.openDialog = true
        this.errorMsg = 'Please type a password'
      } else if (this.password === this.confirmPassword) {
        obj = {
          url: 'auth/setpwd',
          password: this.password,
          email: this.email,
          recaptchaToken: this.captchaToken
        }
        this.$store.dispatch('setNewPassword', obj)
      } else {
        this.openDialog = true
        this.errorMsg = 'Password does not match'
      }
    },
    toLoginPage () {
      this.stp = 0
      this.password = ''
      this.confirmPassword = ''
      this.email = ''
      this.errorMsg = ''
      this.captchaToken = ''
      this.$store.dispatch('resetState')
      this.$router.push('/')
    },
    onSubmit: function () {
      this.$refs.recaptcha.execute()
    },
    onVerify: function (response) {
      this.captchaToken = response
    },
    onExpired: function () {
      console.log('Expired')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login/ResetPassword.vue